module.exports = __webpack_public_path__ + "img/k-business.5d0c186.png";